<template>
  <div>
    <quality-filter @change="onChange" />
    <br />
    <quality-online-data :filter-form="filterForm" />
    <!-- <issue-turn-out-num :filter-form="filterForm" /> -->
    <br />
  </div>
</template>
<script>
import QualityFilter from '@/pages/data/quality/components/QualityFilter';
import QualityOnlineData from '@/pages/data/quality/components/QualityOnlineData';
import IssueTurnOutNum from '@/pages/data/quality/components/IssueTurnOutNum';

export default {
  components: { QualityFilter, QualityOnlineData, IssueTurnOutNum },
  data() {
    return {
      filterForm: {
        begin_date: null,
        end_date: null
      }
    };
  },
  methods: {
    onChange(checkedDate) {
      this.filterForm = {
        begin_date: checkedDate[0].format('YYYY-MM-DD'),
        end_date: checkedDate[1].format('YYYY-MM-DD')
      };
    }
  }
};
</script>
